import { emitter } from 'shared/helpers/mitt';

const FORBIDDEN_FALLBACK_MESSAGE =
  'You do not have permission to perform this action.';

/**
 * Handles pipeline API errors, showing a user-friendly toast for 403 Forbidden responses.
 * Use this in catch blocks of pipeline store actions and component API calls.
 *
 * @param {Error} error - The axios error object
 * @param {Function} [t] - Optional vue-i18n translation function.
 * @returns {Error} - Re-throws the error after handling
 */
export function handlePipelineError(error, t = null) {
  if (error?.response?.status === 403) {
    // Store actions cannot use `useI18n`, so reuse the dashboard-wide i18n
    // instance. Keeping the key as the last-resort value is preferable to a
    // locale-specific hardcoded sentence during early application startup.
    const appI18n =
      typeof window === 'undefined'
        ? null
        : // eslint-disable-next-line no-underscore-dangle
          window.__APP_I18N__;
    const translate = t || appI18n?.global?.t;
    const message = translate
      ? translate('PIPELINE.ERRORS.FORBIDDEN')
      : FORBIDDEN_FALLBACK_MESSAGE;

    emitter.emit('newToastMessage', {
      message,
      action: { type: 'error' },
    });
  }
  throw error;
}
